import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./Download.module.scss";

export const AppDownloadIcon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 0.5C8.55228 0.5 9 0.947715 9 1.5V7.08579L10.7929 5.29289C11.1834 4.90237 11.8166 4.90237 12.2071 5.29289C12.5976 5.68342 12.5976 6.31658 12.2071 6.70711L8.70711 10.2071L8 10.9142L7.29289 10.2071L3.79289 6.70711C3.40237 6.31658 3.40237 5.68342 3.79289 5.29289C4.18342 4.90237 4.81658 4.90237 5.20711 5.29289L7 7.08579V1.5C7 0.947715 7.44772 0.5 8 0.5ZM15 9C15 8.44772 14.5523 8 14 8C13.4477 8 13 8.44772 13 9V13H3V9.58823C3 9.03595 2.55228 8.58823 2 8.58823C1.44772 8.58823 1 9.03595 1 9.58823V14V15H2H14H15V14V9Z" fill="white"/>
    </svg>
  );
};
